<template lang="pug">    
    v-layout.Fotter 
      v-flex(offset-xs3 xs6)
        v-progress-linear(:value="currentLesson.progress" height="5" color="#2a86ca")        
      v-flex(xs1 text-xs-left)
        span.progress-text {{currentLesson.progress}}%
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'Fotter',
  computed: {
    ...mapGetters(['currentLesson'])
  }  
}
</script>

<style scoped>
@import 'lesson-footer.scss';
</style>
